'use strict';
angular.module('schoolLinqApp').factory('vendorService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/vendor';

		function getVendor(id) {
			return $http.get(endpoint + '/' + id);
		}

		function searchVendor(name, statusId, limit) {
			return $http.get(endpoint + '/search', {
				params: { Name: name, StatusId: statusId, Limit: limit },
			});
		}

		function getVendors() {
			return $http.get(endpoint + '/list');
		}

		function getInvoicedVendorsAndOrEmployees(includeEmployeeReimbursements, employeeReimbursementsOnly) {
			return $http.get(endpoint + '/getInvoicedVendorsEmployees', {
				params: {
					IncludeEmployeeReimbursements: includeEmployeeReimbursements,
					EmployeeReimbursementsOnly: employeeReimbursementsOnly,
				},
			});
		}

		function getVendorsByPage(vendorPaging) {
			return $http.post(endpoint + '/getByPage', vendorPaging);
		}

		function getPageIndexForVendor(vendorPaging) {
			return $http.post(endpoint + '/getPageIndexForVendor', vendorPaging);
		}

		function getDeductionRegisterVendors() {
			return $http.get(endpoint + '/getDeductionRegisterVendors');
		}

		function addVendor(vendor) {
			return $http.post(endpoint, vendor);
		}

		function updateVendor(vendor) {
			return $http.put(endpoint, vendor);
		}

		function deleteVendor(vendorId) {
			return $http.delete(endpoint, { params: { id: vendorId } });
		}

		return {
			getVendor: getVendor,
			getVendors: getVendors,
			getInvoicedVendorsAndOrEmployees: getInvoicedVendorsAndOrEmployees,
			getVendorsByPage: getVendorsByPage,
			getPageIndexForVendor: getPageIndexForVendor,
			getDeductionRegisterVendors: getDeductionRegisterVendors,
			addVendor: addVendor,
			updateVendor: updateVendor,
			deleteVendor: deleteVendor,
			searchVendor: searchVendor,
		};
	},
]);
